(function () {
  function initCartDrawerNav(container) {
    if (!container || !container.classList.contains('complementary-products')) {
      return;
    }

    const inner = container.querySelector('.complementary-products--inner');
    const prevButton = container.querySelector('.scroll-nav-button.prev');
    const nextButton = container.querySelector('.scroll-nav-button.next');

    if (!inner || !prevButton || !nextButton) {
      return;
    }

    // Recommendations replace innerHTML asynchronously — always rebind fresh nodes.
    if (container.dataset.cartNavInit === 'true') {
      const clonedPrev = prevButton.cloneNode(true);
      const clonedNext = nextButton.cloneNode(true);
      prevButton.replaceWith(clonedPrev);
      nextButton.replaceWith(clonedNext);
      bindNav(container, inner, clonedPrev, clonedNext);
      return;
    }

    container.dataset.cartNavInit = 'true';
    bindNav(container, inner, prevButton, nextButton);
  }

  function bindNav(container, inner, prevButton, nextButton) {
    function scroll(direction) {
      const card = inner.querySelector('.cart-drawer-product-card');
      const gap = parseFloat(getComputedStyle(inner).gap) || 16;
      const scrollAmount = card ? card.offsetWidth + gap : inner.clientWidth * 0.75;
      const targetScroll =
        direction === 'left' ? inner.scrollLeft - scrollAmount : inner.scrollLeft + scrollAmount;

      inner.scrollTo({ left: targetScroll, behavior: 'smooth' });
    }

    function updateButtonVisibility() {
      const isAtStart = inner.scrollLeft <= 1;
      const isAtEnd = inner.scrollLeft + inner.clientWidth >= inner.scrollWidth - 1;
      const hasScroll = inner.scrollWidth > inner.clientWidth + 1;
      const buttonsContainer = prevButton.closest('.scroll-nav-buttons');

      if (buttonsContainer) {
        buttonsContainer.style.display = hasScroll ? 'flex' : 'none';
      }

      prevButton.style.opacity = isAtStart ? '0.3' : '1';
      nextButton.style.opacity = isAtEnd ? '0.3' : '1';
      prevButton.style.pointerEvents = isAtStart ? 'none' : 'auto';
      nextButton.style.pointerEvents = isAtEnd ? 'none' : 'auto';
      prevButton.disabled = isAtStart;
      nextButton.disabled = isAtEnd;
    }

    function handleComplementaryProductSubmit(evt) {
      evt.preventDefault();
      const form = evt.target;
      const submitButton = form.querySelector('button[type="submit"]');

      if (!submitButton || submitButton.hasAttribute('disabled')) {
        return;
      }

      submitButton.setAttribute('disabled', '');
      submitButton.classList.add('loading');

      fetch(theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript',
        },
        body: new FormData(form),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error('Error:', response.description);
            return;
          }

          document.dispatchEvent(new CustomEvent('cart:refresh'));

          const cartDrawer = document.getElementById('Cart-Drawer');
          if (cartDrawer) {
            document.body.classList.add('open-cc');
            cartDrawer.classList.add('active');
            cartDrawer.focus();
          }

          if (typeof dispatchCustomEvent === 'function') {
            dispatchCustomEvent('cart:item-added', {
              product: Object.prototype.hasOwnProperty.call(response, 'items')
                ? response.items[0]
                : response,
            });
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally(() => {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
        });
    }

    prevButton.addEventListener('click', (event) => {
      event.preventDefault();
      scroll('left');
    });
    nextButton.addEventListener('click', (event) => {
      event.preventDefault();
      scroll('right');
    });
    inner.addEventListener('scroll', updateButtonVisibility, { passive: true });
    window.addEventListener('resize', updateButtonVisibility);

    inner.querySelectorAll('.product-form').forEach((form) => {
      form.addEventListener('submit', handleComplementaryProductSubmit);
    });

    // Wait a frame so card widths are measured after images/layout settle.
    requestAnimationFrame(() => {
      updateButtonVisibility();
      setTimeout(updateButtonVisibility, 150);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.cart-drawer .complementary-products').forEach(initCartDrawerNav);
  }

  // Called by ProductRecommendations after async HTML inject (app.js).
  window.initComplementaryProductsNav = function (element) {
    if (element) {
      delete element.dataset.cartNavInit;
      initCartDrawerNav(element);
      return;
    }
    initAll();
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('complementary-products:loaded', (event) => {
    const element = event.detail && event.detail.element;
    if (element) {
      delete element.dataset.cartNavInit;
      initCartDrawerNav(element);
    } else {
      initAll();
    }
  });
  document.addEventListener('cart-drawer:open', () => {
    requestAnimationFrame(() => initAll());
  });
})();
